import React, { useState, useEffect } from "react";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import RequestServies from "../../../services/RequestServices";
import Swal from 'sweetalert2';

function ApproveOrRejectRequisitionModal({ show, item, handleClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [errormsg, setErrormsg] = useState();
  const [previewImage, setPreviewImage] = useState("");
  const [formValues, setFormValues] = useState({
    inventory: item?._id,
    partNo: 0,
    transfer: "",
    totalRecive: "",
    description: "",
    unit: "",
    remark: "",
    qtyAuth: 0,
    currentStock: 0,
    demand: 0,
    transferQty: 0,
    indigoStock: 0,
    approveQty: 0,
    user: "",
    store: "",
    image: null,
  });

  useEffect(() => {
    if (item) {
      setFormValues({
        ...formValues,
        partNo: item?.inventory?.masterItem?.partNo || 0,
        totalRecive: item?.inventory?.totalRecive || 0,
        qtyAuth: item?.inventory?.qtyAuth || 0,
        description: item?.inventory?.masterItem?.description || "",
        unit: item?.inventory?.masterItem?.unit?.name || "",
        currentStock: item?.inventory?.currentStock || 0,
        demand: item?.inventory?.qtyAuth - item?.inventory?.currentStock || 0,
        user: item?.user?.name || " ",
        store: item?.transfer?.storeTo?.name || "",
        transferQty: item?.transferQty || 0,
        transfer: item?.transfer?.transferNo || 0,
        approveQty: item?.transferQty || 0,
        adminRemark: "",
      });
      if (item?.transfer?.image) {
        setPreviewImage(
          "https://indigoinfra.in/img/transferForm/" + item?.transfer?.image
        );
      }
    }
  }, [item]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
    if (name === "approveQty") {
      if (value > formValues.transferQty) {
        setErrormsg("Quantity required should be less than or equal to Transfer Qty");
      } else {
        setErrormsg("");
      }
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

  const handleSubmit = async (event, status) => {
    event.preventDefault();

    if (formValues.approveQty > formValues.transferQty) {
      Swal.fire({
        title: 'Error!',
        text: 'Approve Qty should be Equal or Less than Transfer Qty!',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }

    try {
      setLoading(true); // disable button while submitting

      const formData = new FormData();
      for (const key in formValues) {
        if (key !== "image" || formValues[key] instanceof File) {
          formData.append(key, formValues[key]);
        }
      }

      await RequestServies.updateTransferItem(item._id, {
        approveQty: formValues.approveQty,
        status: status,
        adminRemark: formValues.remark,
      });

      onSuccess();

      Swal.fire({
        title: 'Success!',
        text: 'Successfully Approved',
        icon: 'success',
        confirmButtonText: 'OK',
      });

      handleClose();

    } catch (error) {
      console.error('Error Response:', error.response?.data?.message);
      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.message || "An unexpected error occurred",
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      setLoading(false); // re-enable button after request completes
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>Approval Transfer Item Form</Modal.Title>
          <Button variant="close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md="6">
                <label>Part No</label>
                <input
                  type="number"
                  name="partNo"
                  className="form-control form-control-sm"
                  value={formValues.partNo}
                  readOnly
                />
              </Col>

            </Row>
            <Row>
              <Col md="12">
                <label>Description</label>
                <textarea
                  rows="3"
                  name="description"
                  className="form-control form-control-sm"
                  value={formValues.description}
                  readOnly
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Unit</label>
                <input
                  type="text"
                  name="unit"
                  className="form-control form-control-sm"
                  value={formValues.unit}
                  readOnly
                />
              </Col>
              <Col md="6">
                <label>Total Auth</label>
                <input
                  type="number"
                  name="qtyAuth"
                  className="form-control form-control-sm"
                  value={formValues.qtyAuth}
                  readOnly
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Total Received</label>
                <input
                  type="number"
                  name="totalRecive"
                  className="form-control form-control-sm"
                  value={formValues.totalRecive}
                  readOnly
                />
              </Col>
              <Col md="6">
                <label>Current Stock</label>
                <input
                  type="number"
                  name="currentStock"
                  className="form-control form-control-sm"
                  value={formValues.currentStock}
                  readOnly
                />
              </Col>
            </Row>
            <Row>

              <Col md="6">
                <label>Qty Transfer</label>
                <input
                  type="number"
                  name="transferQty"
                  className="form-control form-control-sm"
                  value={formValues.transferQty}
                  readOnly
                />
              </Col>
              <Col md="6">
                <label>approveQty Transfer</label>
                <input
                  type="number"
                  name="approveQty"
                  className="form-control form-control-sm"
                  value={formValues.approveQty}
                  onChange={handleInputChange}
                />
                <p>{errormsg}</p>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Indigo Stock</label>
                <input
                  type="number"
                  name="indigoStock"
                  className="form-control form-control-sm"
                  value={formValues.indigoStock}
                  onChange={handleInputChange}
                />
              </Col>
              <Col md="6">
                <label>Store Keeper</label>
                <input
                  type="text"
                  name="user"
                  className="form-control form-control-sm"
                  value={formValues.user}
                  readOnly
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Reciver Store</label>
                <input
                  type="text"
                  name="store"
                  className="form-control form-control-sm"
                  value={formValues.store}
                  readOnly
                />
              </Col>
              <Col md="6">
                <div className="input-field">
                  <div className="file-preview text-center">
                    <img
                      id="uploadFile"
                      src={previewImage}
                      alt="Preview"
                      className="img-fluid"
                    />
                  </div>

                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>

          <Button
            variant="primary"
            type="submit"
            onClick={(e) => handleSubmit(e, "approved")}
            disabled={loading} // disables button while submitting
          >
            {loading ? "Submitting..." : "Approve"}
          </Button>

          <Button variant="danger" onClick={(event) => handleSubmit(event, 'rejected')}>
            Reject
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default ApproveOrRejectRequisitionModal;
